module.exports = __webpack_public_path__ + "img/updata-userData_logo.fb70fb2e.svg";